import { $api } from "../generated/client";

type ReturnReasonsAnalyticsParams = {
	fromTimestamp: number;
	toTimestamp: number;
	productId?: string;
	variantId?: string;
	shopId: string;
	resolution?: string;
	reason?: string;
};

export default function useReturnReasonsAnalytics({
	shopId,
	...params
}: ReturnReasonsAnalyticsParams) {
	return $api.useQuery("get", "/shops/{shopId}/analytics/return-reasons", {
		params: { path: { shopId }, query: params },
		enabled: !!params.toTimestamp,
	});
}
